const checkFileSize = event => {
  let files = event.target.files
  let size = 6000000
  let err = ''
  for (var x = 0; x < files.length; x++) {
    if (files[x].size > size) {
      err += 'Essa imagem é muito grande, escolha uma imagem menor'
    }
  }
  if (err !== '') {
    event.target.value = null
    console.log(err)
    return { err }
  }

  return true
}

export default checkFileSize
